"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Storage: () => Storage
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_validate = require("./validate");
var hybrid;
function getItem(key) {
  if (typeof key !== "string" || key === "") (0, import_validate.invalidKey)("Storage.getItem");
  try {
    var _getItem;
    return (_getItem = (hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneStorage")).getItem(key)) !== null && _getItem !== void 0 ? _getItem : null;
  } catch (error) {
    (0, import_nativeError.rethrowNativeError)(error);
  }
}
function setItem(key, value) {
  if (typeof key !== "string" || key === "") (0, import_validate.invalidKey)("Storage.setItem");
  if (typeof value !== "string") (0, import_validate.invalidValue)("Storage.setItem");
  try {
    ;
    (hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneStorage")).setItem(key, value);
  } catch (error) {
    (0, import_nativeError.rethrowNativeError)(error);
  }
}
function removeItem(key) {
  if (typeof key !== "string" || key === "") (0, import_validate.invalidKey)("Storage.removeItem");
  try {
    ;
    (hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneStorage")).removeItem(key);
  } catch (error) {
    (0, import_nativeError.rethrowNativeError)(error);
  }
}
function getAllKeys() {
  try {
    return (hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneStorage")).getAllKeys();
  } catch (error) {
    (0, import_nativeError.rethrowNativeError)(error);
  }
}
var Storage = Object.freeze({
  getItem,
  setItem,
  removeItem,
  getAllKeys
});
//# sourceMappingURL=index.native.js.map
